
import img1 from '../../../Assets/Blog/Hall_of_Fame_Selections_2022_v2.jpg';
import img2 from '../../../Assets/Blog/portfolio_showdown_square.png';
import img3 from '../../../Assets/Blog/Jessica_Coats_Image.jpeg';
import img4 from '../../../Assets/Blog/closeup-of-blogger-hands-using-data-on-mobile-smar-2021-11-03-01-17-56-utc__1_.jpg';
import img5 from '../../../Assets/Blog/Blog_Featured.jpg';

const Data =  [
        {
            key: 1,
            img: img1,
            title: "Maven News",
            heading: "Maven Analytics Hall of Fame 2022: Call for Nominations",
            author: "By Johan Puler"
        },
        {
            key: 2,
            img: img2,
            title: "DATA CHALLENGES",
            heading: "Introducing the Maven Portfolio Showdown",
            author: "By Johan Puler"
        },
        {
            key: 3,
            img: img3,
            title: "BUSINESS INTELLIGENCE CAREERS",
            heading: "Analysts You Can Hire",
            author: "By Johan Puler"
        },
        {
            key: 4,
            img: img4,
            title: "BUSINESS INTELLIGENCE CAREERS",
            heading: "Data Influencers to Follow",
            author: "By Johan Puler"
        },
        {
            key: 5,
            img: img5,
            title: "ONLINE LEARNING",
            heading: "Lessons from My First 100 Days of Bootcamp",
            author: "By Johan Puler"
        },
        {
            key: 6,
            img: img1,
            title: "ONLINE LEARNING",
            heading: "The Benefits of Maven's Data Analyst Bootcamp",
            author: "By Johan Puler"
        },
        {
            key: 7,
            img: img3,
            title: "DATA CHALLENGES",
            heading: "How Much Time Should I Spend Cleaning Data?",
            author: "By Johan Puler"
        },
        {
            key: 8,
            img: img1,
            title: "MAVEN NEWS",
            heading: "Welcome Gerard Duggan! Maven Analytics Hall Of Fame",
            author: "By Johan Puler"
        },
        {
            key: 9,
            img: img2,
            title: "BUSINESS INTELLIGENCE CAREERS",
            heading: "How Tom Vine Launched His Dream Career at Alpine F1",
            author: "By Johan Puler"
        },
        {
            key: 10,
            img: img2,
            title: "DATA CHALLENGES",
            heading: "Introducing the Maven Portfolio Showdown",
            author: "By Johan Puler"
        },

    ]
export default Data;